import axiosInstance from 'services/axiosInstance';
import { IResponse } from 'services/types';
import { ICrmSourceInfo, IPodWebExtensionConfiguration } from 'services/webExtension/types';

export const getDefaultPsaId = (
  crmType: string,
): IResponse<number> =>
  axiosInstance.request({
    method: 'GET',
    url: `PodWebExtensions/crm?crmType=${crmType}`,
  });

export const getPodConfiguration = (): IResponse<IPodWebExtensionConfiguration> =>
  axiosInstance.request({
    method: 'GET',
    url: 'PodWebExtensions/configuration',
    validateStatus: () => true,
  });

// Every PSA integration configured for this tenant, including site URLs.
// See MSPPROC-17664 (ConnectWise ticket detection).
export const getCrmSources = (): IResponse<ICrmSourceInfo[]> =>
  axiosInstance.request({
    method: 'GET',
    url: 'CrmSource',
  });
